<div *ngIf="block"
    class="container-page-general position-relative d-flex flex-column justify-content-end align-items-center">
    <div *ngIf="!isSecondLevelUp" class="container-page-general__title w-100 text-center">
        <h1 *ngIf="titlePage" class="ls-h1-page-title text-brand-10 text-start text-lg-center px-3 px-lg-0 mb-4" [innerHTML]="titlePage"></h1>
    </div>
</div>
<ng-container *ngIf="node && isSpinner; else spinner">
    <!-- <div *ngIf="isSecondLevelUp" class="container-field-taxonomies"> -->
    <div class="container-field-taxonomies" *ngIf="block">
        <!-- DEFAULT PAGINA FIELD -->
        <app-container-field-taxonomies [dataFieldTaxonomies]="dataFieldTaxonomies" [typeOfContent]="'convenzione'"></app-container-field-taxonomies>
        <!-- END DEFAULT PAGINA FIELD -->
    </div>
    <!-- Anchor -->
    <app-sample-anchor *ngIf="anchorItems && !isSecondLevelUp" [anchorItems]="anchorItems" [idAnchor]="idAnchor"
        [positionType]="'mt-2'" [bgColor]="'white'" [setOffset]="250" [positionTop]="'120px'" [styleHeader]="'second'">
    </app-sample-anchor>
    <!-- END Anchor -->
    <!-- HEADER COLLAPSE -->
    <div *ngIf="block && node" id="collapse" [ngClass]="{
        'opacity-100 visible bg-neutral-A1': isCollapseHeader,
        'opacity-0 invisible bg-neutral-99': !isCollapseHeader
        }" class="container-page-general-collapse position-fixed no-print">
        <div class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom">
            <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
                <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone"
                    src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand"
                    style="margin-left: 34px;" (click)="openMenu()">
            </div>
            <p *ngIf="titlePage" class="ls-h1-page-title-collapse col-10 mb-1" [ngClass]="{'offset-md-1': !isShowLocalMenu}"
                [innerHTML]="titlePage">
        </p>
            <!-- <h1 *ngIf="titlePage" class="ls-h1-page-title-collapse offset-md-1 col-10" [innerHTML]="titlePage"></h1> -->
            <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
                'col-1': titlePage && isShowLocalMenu,
                'col-11': !titlePage && isShowLocalMenu,
                'col-12': !titlePage && !isShowLocalMenu
            }">
                <div class="cursor-pointer" (click)="helpersService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon"
                        style="margin-right: 34px;">
                </div>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp && anchorItems.length" class="border-bottom-custom" style="padding: 16px 10px;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [styleHeader]="'collapse'"
                [positionTop]="'140px'" [bgColor]="'transparent'" [setOffset]="250">
            </app-sample-anchor>
        </div>
    </div>
    <!-- END HEADER COLLAPSE -->
    <div *ngIf="block" class="container container-description mt-5" [innerHTML]="block.field_descrizione">
    </div>
    <!-- ROW -->
    <ng-container *ngIf="node.field_layout_righe && node.field_layout_righe.length">
        <div class="container-row">
            <div *ngFor="let row of node.field_layout_righe; let idx = index">
                <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx" [attr.rowid]="row.target_id"
                    [preview]="node.preview" (objAnchor)="addNewAnchorItem($event)">
                </app-row>
            </div>
        </div>
    </ng-container>
    <!-- END ROW -->
    <div *ngIf="node.created[0].value" class="mt-5 mb-5 d-flex flex-wrap justify-content-between w-100 container container-published" style="gap: 20px 0;">
        <div class="col-12 col-sm-8 order-1 ordder-sm-0">
            <div class="d-flex w-100 mb-2">
                <p class="text-neutral-30 ls-label-medium-semibold mb-0 me-1">
                    {{ "CONTENT_TYPES.CONTENT_PUBLISHED" | translate }}
                </p>
                <p class="text-neutral-30 ls-label-medium-semibold mb-0">
                    {{ node.created[0].value | localizedDate: 'dd MMMM yyyy - HH:MM'}}
                </p>
            </div>
            <div class="d-flex w-100" *ngIf="node.changed[0].value">
                <p class="text-neutral-30 ls-p-small mb-0 me-1">
                    {{ "CONTENT_TYPES.LAST_MODIFIED" | translate }}
                </p>
                <p class="text-neutral-30 ls-p-small mb-0">
                    {{ node.changed[0].value | localizedDate: 'dd MMMM yyyy - HH:MM'}}
                </p>
            </div>
        </div>
        <div class="container-page-general__container-share cursor-pointer col-12 col-sm-4 col-md-3 order-0 order-sm-1" (mouseenter)="onHoverShare = true"
            (mouseleave)="onHoverShare = false" (click)="helpersService.openModaleShare()">
            <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
            <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
        </div>
    </div>
    </ng-container>
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>